module.exports = __webpack_public_path__ + "img/Home_Mobile_04.d1bd67ff.jpg";